import { render } from "./Banco.vue?vue&type=template&id=e6e929ee"
import script from "./Banco.vue?vue&type=script&lang=js"
export * from "./Banco.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__